<app-guided-tour *ngIf="guidedTourInstantiated$ | async"></app-guided-tour>
<app-practice-agent-widget></app-practice-agent-widget>
<div class="page-container" [ngClass]="{ unauth: !(authenticated$ | async) }">
  <div class="spinner-container" *ngIf="displayProgressSpinner$ | async">
    <mat-spinner class="spinner"></mat-spinner>
  </div>
  <header *ngIf="(authenticated$ | async) && !router.url.includes('login')">
    <app-header></app-header>
  </header>

  <main>
    <div class="content">
      <ng-content></ng-content>
    </div>
    <div class="side-content" [hidden]="!(authenticated$ | async) || router.url.includes('login')"
      [ngClass]="{ flyover: sidebarFlyout$ | async }">
      <div #sidebar></div>
    </div>
    <aside *ngIf="(authenticated$ | async) && !router.url.includes('login')">
      <div class="side-menu">
        <app-side-nav></app-side-nav>
      </div>
    </aside>
  </main>
</div>
